export class Purpose {
	id?: number;
	name?: string;

	constructor(init?: Partial<Purpose>) {
		Object.assign(this, init);
	}
}
